import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';

import { GetTagGroupListService } from './api-services/get-tag-group-list.service';
import { KYMW0002Component } from './kymw0002.component';

/**
 * タグ選択画面 モジュール設定クラス
 *
 * @export KYMW0002Module
 * @class KYMW0002Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjInputModule,
    WjNavModule,
  ],
  declarations: [KYMW0002Component],
  providers: [GetTagGroupListService],
})
export class KYMW0002Module {}
